// extracted by css-extract-rspack-plugin
export default {"toggleChip":"Z8L_lejAOiIwI59n","chip":"iwqCBuXgLwU_qB9s","removeButton":"qcVSPbZwlsYW1099"};